import { requestApi } from './Api';

export const getProducts = (navigate, params) =>
  requestApi({
    navigate,
    url: 'api/product/get',
    params,
    onError: () => {}
  });

export const getProductCategories = (navigate, params) =>
  requestApi({
    navigate,
    url: 'api/product/category/get',
    params,
    onError: () => {}
  });

export const checkProductAvailability = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/product/check_availability',
    params,
    onError: () => {}
  });
